const theme = {
	images: {
		logo: "https://cdn4.fincaraiz.com.co/web/5ee3722bdec05_infocdn__logo-infocasas@2x.png",
		isotipo: "https://cdn4.fincaraiz.com.co/web/5fa45366ae1fb_infocdn__isotipo.png",
		favicon: "https://cdn4.fincaraiz.com.co/web/5ee376daa7764_infocdn__favicon.ico",
		icono: "https://cdn4.fincaraiz.com.co/web/5ee372edae68f_infocdn__app@2x.png",
	},
	fontFamily: "InfoCasasSans, system, -apple-system, Roboto, Segoe UI Bold, Arial, sans-serif",
	colors: {
		primaryColor: "#FC7315",
		primaryHoverColor: "#F25D28",
		primaryDarkColor: "#F25D28",
		secondaryColor: "#00BBAF",
		primaryColorV2: '#35394E',
		primaryLightColor: "#ffa700",
		secondaryDarkColor: "#00BBAF",
		secondaryOpacityColor: "rgba(1,187, 175,0.25)",
		secondaryHoverColor: "#007882",
		textColorHigh: "#000",
		textColorMedium: "#3A4145",
		textColorLow: "#3A4145",
		textSecondaryColor: "#808485",
		textOnSecondaryColor: "#fff",
		textInverseColor: "#a7a7a7",
		textHoverColor: "#fff",
		textLinkSecondary: "#007882",
		backgroundColor: "#fff",
		backgroundMainColor: "#fc7b27",
		backgroundModalColor: "rgba(0, 0, 0, 0.5)",
		backgroundMenuColor: "#3A4145",
		textMenuColor: "#FFFFFF",
		linkColor: "#FC7315", // == secondaryColor
		linkHoverColor: "#F25D28", // == secondaryHoverColor
		backgroundColorAternative: "#FAFAFA",
		borderColor: "#E9E9E9",
		favoriteColor: "#ff6767",
		successColor: "#69AD6C",
		errorColor: "#F24E1E",
		warningColor: "#fff3cd",
		placeholderTextColor: "#cccccc",
		contentButtonColor: "#f07238",
		backgroundHighColor: "#FF4A1E",
		backgroundMediumColor: "#FF8500",
	},
	breakPoints: {
		xs: "576px",
		sm: "576px",
		md: "768px",
		lg: "992px",
		xl: "1200px",
		xxl: "1600px",
	},
	headerHeight: 64,
	spacing: {
		xsSpacing: 4,
		smSpacing: 8,
		mdSpacing: 12,
		lgSpacing: 16,
		xlSpacing: 24,
		xxlSpacing: 32,
	},
	fontSizes: {
		baseFontSize: "16px",
		baseLineHeight: 1.5,

		lgFontSize: "18px",
		smFontSize: "14px",
		xsFontSize: "12px",

		xlTitle: "32px",
		xlLineHeight: "40px",
		lgTitle: "28px",
		lgLineHeight: "36px",
		mdTitle: "24px",
		mdLineHeight: "32px",
		smTitle: "20px",
		smLineHeight: "28px",
		xsTitle: "18px",
		xsLineHeight: "24px",
	},
};

module.exports = theme;

